module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', {
    staticClass: "p-executive-dashboard__summary"
  }, [_vm._v("\n        Our Executive Dashboard provides a snapshot of key quantum and reserving data on your book of business."), _c('br'), _c('br'), _vm._v("\n        You can drill down into your live and concluded claims data.\n    ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-18949853!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/executive-dashboard/components/PageHeader.vue
// module id = 1590
// module chunks = 0